module.exports = __webpack_public_path__ + "static/media/brown.c02bfe4b.png";